<div class="field-passport-container">
  <div class="h-full">
    <div class="card-container p-3">
      <div class="flex justify-content-between align-items-center mb-3 w-full">
        <h2 class="m-0">{{ "General information" | translate }}</h2>
        <div class="flex gap-2">
          <button
            pButton
            type="button"
            [label]="'Export' | translate"
            icon="pi pi-download"
            class="p-button"
            (click)="menu.toggle($event)"
            [disabled]="isExporting">
            <ng-container *ngIf="isExporting">
              <i class="pi pi-spin pi-spinner" style="margin-left: 8px;"></i>
            </ng-container>
          </button>
          <p-menu
            #menu
            [model]="exportMenuItems()"
            [popup]="true"
            appendTo="body">
          </p-menu>
          <button
            pButton
            type="button"
            label="{{ 'Edit' | translate }}"
            class="p-button-sm edit-btn"
            (click)="openEditModal()">
            <img
              src="../../../../../../../../assets/icons/main/light/edit-icon.svg"
              alt="Edit"
              class="edit-icon" />
          </button>
        </div>
      </div>

      <div class="field-info-container">
        <div class="flex flex-row">
          <div class="image-section col-5">
            <div class="field-image">
              <app-passport-general-map
                [activeSeasons]="mapScopeSeasons"
                [activeCrops]="mapScopeCrops"
                [field]="passportManager?.field()?.entity"
                [(multiPolygonJson)]="multiPolygonJson"></app-passport-general-map>
            </div>
          </div>
          @if (isLoading) {
            <app-loading [loading]="isLoading"></app-loading>
          } @else {
            <div class="flex flex-column col-7 gap-2">
              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Field Name" | translate }}</span>
                </div>
                <div class="flex">
                  <span class="value text-sm">{{ passportManager.field()?.entity?.name || "-" }}</span>
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Bonitet score" | translate }}</span>
                </div>
                <div class="flex">
                  <span class="value text-sm">{{ passportManager?.field()?.entity?.bonitetScore || "-" }}</span>
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Total Area" | translate }}</span>
                </div>
                <div class="flex">
                  <span class="value text-sm">
                    {{ (passportManager?.totalArea() | msfNumber) || "-" }} {{ "Ha" | translate }}
                  </span>
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Used Area" | translate }}</span>
                </div>
                <div class="flex">
                  <span class="value text-sm">
                    {{ passportManager.usedArea() | number: "1.2-2" }} {{ "Ha" | translate }}
                  </span>
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Soil type" | translate }}</span>
                </div>
                @if (isLoadingMetaData) {
                  <ng-container *ngTemplateOutlet="loading"></ng-container>
                } @else {
                  <div class="flex">
                    <span class="value text-sm">{{ (soilType | serverTranslate: "names") || "-" }}</span>
                  </div>
                }
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Soil Context" | translate }}</span>
                </div>
                <div class="flex">
                  <span class="value text-sm">
                    @if (passportManager?.field()?.entity?.openClosedSoil === 1) {
                      {{ "Open Soil" | translate }}
                    } @else if (passportManager?.field()?.entity?.openClosedSoil === 2) {
                      {{ "Closed Soil" | translate }}
                    } @else {
                      -
                    }
                  </span>
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Field Type" | translate }}</span>
                </div>
                <div class="flex">
                  @if (isLoadingMetaData) {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                  } @else {
                    <span class="value text-sm">{{ (fieldType | serverTranslate: "names") || "-" }}</span>
                  }
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Region" | translate }}</span>
                </div>
                <div class="flex">
                  @if (isLoadingMetaData) {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                  } @else {
                    <app-region-display
                      [regionId]="passportManager?.field()?.entity?.regionId"
                      align="right"
                      cssClass="value text-sm"></app-region-display>
                  }
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Agroclimatic zone (ID)" | translate }}</span>
                </div>
                <div class="flex">
                  @if (isLoadingMetaData) {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                  } @else {
                    <span class="value text-sm">{{ this.agroclimaticZone | serverTranslate: "names" }}</span>
                  }
                </div>
              </div>
              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Classifier" | translate }}</span>
                </div>
                <div class="flex">
                  <span class="value text-sm">{{ passportManager?.field()?.entity?.classifier }}</span>
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Altitude above sea level" | translate }}</span>
                </div>
                <div class="flex">
                  <span class="value text-sm">
                    {{
                      passportManager?.field()?.entity?.altitudeAboveSeaLevel
                        ? (passportManager?.field()?.entity?.altitudeAboveSeaLevel | msfNumber) +
                          " " +
                          ("m" | translate)
                        : "-"
                    }}
                  </span>
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Cadastre" | translate }}</span>
                </div>
                <div class="flex">
                  <span class="value text-sm">{{ passportManager?.field()?.entity?.cadastralNumber }}</span>
                </div>
              </div>

              <div class="flex flex-row justify-content-between">
                <div class="flex">
                  <span class="label font-semibold text-sm">{{ "Comment" | translate }}</span>
                </div>
                <div class="flex">
                  <span class="value italic text-sm">{{ passportManager?.field()?.entity?.comment || "-" }}</span>
                </div>
              </div>
            </div>
          }
        </div>

        <div class="checkbox-examples">
          <app-checkbox
            [(ngModel)]="fieldStatus"
            [label]="'Publish' | translate"></app-checkbox>
        </div>
      </div>

      <br />
      <app-passport-menu-general-history
        #historyComponent
        [fieldId]="fieldId"
        [formConfig]="passportManager.getEditFieldFormConfig()"
        (historyRestored)="loadField(fieldId, true)"></app-passport-menu-general-history>
    </div>
    <ng-template #loading>
      <app-loading
        [loading]="true"
        [height]="'20px'"
        [width]="'20px'"
        [align]="'start'"></app-loading>
    </ng-template>
  </div>
</div>
